<div *ngIf="isAvailableStatistics"
     class="bookmark"
     data-test="favorite"
     [class.favorite]="isFavorite"
     (click)="onToggleFavorite()">
  <app-icon class="tool-icon" icon="favorites"></app-icon>
  <ng-template [ngIf]="!deviceService.isMobile() && !notooltip">
    <ng-container *ngTemplateOutlet="tooltip; context: { title: isFavorite ?
       'teacher-card.titles.remove-favorites' : 'teacher-card.titles.add-favorites' }">
    </ng-container>
  </ng-template>
</div>

<ng-template #tooltip let-title="title" let-subtitle="subtitle">
  <div class="tooltip">
    <span class="tooltip-title normal">{{ title | translate }}</span>
  </div>
</ng-template>
